var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSalesReturnActiveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24.004,
    height: 24,
    rx: 4,
    fill: "#6C42A9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 4H4v16h16V4z",
    fill: "#6C42A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.525 10.457h4.262v.925H8.526v-.925zM8.525 8.731h5.594v.926H8.525V8.73z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.88 13.74h2.81l-.826-.886.323-.351 1.385 1.487-1.384 1.487-.324-.351.826-.889h-2.81c-.34-.029-.677.11-.936.39-.259.277-.42.672-.448 1.097.028.426.189.82.448 1.1.26.278.595.417.936.388h1.845v.497H12.88c-.454.04-.903-.147-1.248-.518-.345-.372-.56-.898-.597-1.466.037-.567.251-1.094.597-1.465.345-.372.794-.558 1.248-.52z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.216 11.61V6.935a.885.885 0 0 0-.115-.499.579.579 0 0 0-.415-.149H7.912a.526.526 0 0 0-.389.121.753.753 0 0 0-.09.453L7.545 17.5h.62l1.049-1.854 1.219 1.571",
    stroke: "#fff",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesReturnActiveIcon);
export default __webpack_public_path__ + "static/media/salesReturnActiveIcon.4eb7b0639462a9ba5c99957b27bc6132.svg";
export { ForwardRef as ReactComponent };